import React, { useEffect, useState } from "react";

export const About = ({ isLight }) => {
  const [show, setShow] = useState({ show1: false, show2: false, show3: false });

  useEffect(() => {
    const t1 = setTimeout(() => setShow(s => ({ ...s, show1: true })), 200);
    const t2 = setTimeout(() => setShow(s => ({ ...s, show2: true })), 600);
    const t3 = setTimeout(() => setShow(s => ({ ...s, show3: true })), 1000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  const textColor = isLight ? 'text-slate-900' : 'text-white';
  const subTextColor = isLight ? 'text-slate-600' : 'text-white/80';
  const highlightColor = isLight ? 'text-cyan-600' : 'text-cyan-300';

  return (
    <div className={`rounded-lg p-10 border animate-in backdrop-blur-md transition-all duration-500 shadow-2xl ${
      isLight ? 'bg-white/80 border-slate-200' : 'bg-[#111114]/80 border-white/10'
    }`}>
      <div className="w-full flex flex-col items-center gap-12">
        {/* Section 1: What is Lucy? */}
        <section className={`max-w-2xl w-full text-center transition-all duration-700 ${show.show1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h3 className={`text-md md:text-lg font-black mb-4 tracking-[0.2em] uppercase ${highlightColor}`}>What is Lucy?</h3>
          <p className={`text-md md:text-lg leading-relaxed ${subTextColor}`}>
            Lucy is a smart, simple way to safeguard you from fraudulent URLs. <br className="hidden md:block" />
            <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`}>Powered by AI</span>, it analyzes links in real-time and provides quick insights.
          </p>
        </section>

        {/* Section 2: About Us */}
        <section className={`max-w-2xl w-full text-center transition-all duration-700 ${show.show2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h3 className={`text-md md:text-lg font-black mb-4 tracking-[0.2em] uppercase ${highlightColor}`}>About Us</h3>
          <p className={`text-md md:text-lg mb-8 ${subTextColor}`}>
            We are students from the Computer Science and Engineering department at <span className={`font-bold ${textColor}`}>NIT, Surat</span>.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
            <div className={`p-4 rounded border ${isLight ? 'bg-slate-50 border-slate-200' : 'bg-white/5 border-white/10'}`}>
              <span className={`text-[10px] font-black uppercase tracking-widest block mb-2 ${isLight ? 'text-slate-400' : 'text-slate-500'}`}>The Team</span>
              <div className="flex flex-col gap-2">
                <a href="https://github.com/AnushkaKundu" target="_blank" rel="noopener noreferrer" className={`text-sm hover:text-cyan-500 transition ${textColor}`}>Anushka Kundu</a>
                <a href="https://github.com/Suthar-Dev" target="_blank" rel="noopener noreferrer" className={`text-sm hover:text-cyan-500 transition ${textColor}`}>Dev Suthar</a>
                <a href="https://github.com/gobbledy-gook" target="_blank" rel="noopener noreferrer" className={`text-sm hover:text-cyan-500 transition ${textColor}`}>Gobbledy</a>
              </div>
            </div>
            
            <div className={`p-4 rounded border ${isLight ? 'bg-slate-50 border-slate-200' : 'bg-white/5 border-white/10'}`}>
              <span className={`text-[10px] font-black uppercase tracking-widest block mb-2 ${isLight ? 'text-slate-400' : 'text-slate-500'}`}>Mentor</span>
              <p className={`text-sm font-bold ${textColor}`}>Dr. Dhiren Patel</p>
              <p className={`text-[10px] uppercase mt-1 ${isLight ? 'text-slate-500' : 'text-slate-400'}`}>CSE Professor at NIT, Surat</p>
            </div>
          </div>
        </section>

        {/* Section 3: Closing */}
        <section className={`max-w-2xl w-full text-center transition-all duration-700 ${show.show3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className={`h-px w-full mb-8 ${isLight ? 'bg-slate-200' : 'bg-white/10'}`} />
          <span className={`italic font-bold text-base uppercase tracking-widest ${isLight ? 'text-slate-400' : 'text-white/60'}`}>
            Let’s make Humans safer, together!
          </span>
        </section>
      </div>
    </div>
  );
};